<ng-template #barterView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div>
            <div class="card-title">
                <h1>{{ 'MODALS.HEADERS.BARTER' | translate }}</h1>
            </div>
            <div *ngIf="isMaster" class="card-body">
                <div class="row">
                    <div class="col-12">
                        <h2>{{ 'MODALS.TEXT.FROM_WALLET' | translate }}: {{ outWallet.title }}</h2>
                    </div>

                    <div class="col-12">
                        <label for="inWallet">{{ 'MODALS.FIELDS.TO_WALLET' | translate }}: </label>
                        <select #inWallet class="form-control form-select form-control-lg" id="inWallet">
                            <option hidden selected>{{ 'MODALS.FIELDS.SELECT.WALLET' | translate }}</option>
                            <option *ngFor="let wallet of wallets" [disabled]="!wallet.active"
                                    [value]="wallet.guid">{{ wallet.title }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12">
                        <label for="inputTotal">{{ 'MODALS.FIELDS.SUM' | translate }}</label>
                        <input #inputTotal class="form-control form-control-lg form-block" id="inputTotal">
                    </div>
                </div>
                <button (click)="onBarterEvent(inWallet,inputTotal, modal)"
                        [disabled]="isLockButton"
                        class="btn btn-primary btn-lg btn-block m-2"
                        type="submit">
                    <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.TRANSFER' | translate }}</span>
                </button>
            </div>

            <div *ngIf="!isMaster" class="card-body">
                <div class="row">
                    <div *ngIf="masterWallet" class="col-12">
                        <h2>{{ 'MODALS.TEXT.FROM_WALLET' | translate }}: {{ masterWallet.title }}</h2>
                    </div>

                    <div class="col-12">
                        <label for="inWallet">{{ 'MODALS.FIELDS.TO_WALLET' | translate }}: {{ outWallet.title }}</label>
                    </div>
                    <div class="col-12">
                        <label for="inputTotal2">{{ 'MODALS.FIELDS.SUM' | translate }}</label>
                        <input #inputTotal class="form-control form-control-lg form-block" id="inputTotal2">
                    </div>
                </div>
                <button (click)="onBarterEvent(null, inputTotal, modal)"
                        [disabled]="isLockButton || loading"
                        class="btn btn-primary btn-lg btn-block m-2"
                        data-action="createBarter"
                        type="submit">
                    <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.TRANSFER' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
